import React, { useCallback, useState, useEffect } from 'react';
// import 'antd/dist/antd.css';
import { Form, Input, Button, Typography, Row, Col, Layout, Card, message } from 'antd';
import { localStorageUtils } from '../../../../utils/localStorageUtils'
import axios from 'axios';
import './Login.scss';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import queryString from 'query-string';
import { DataContext } from '../../../../Context/DataContext.js';

const { Title, Text } = Typography;
const { Footer } = Layout;


function Login() {
  const { t } = React.useContext(DataContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  let params = queryString.parse(location.search)
  const [isLogin, setIsLogin] = useState(false)
  useEffect(() => {
    if (params.status) {
      message.error(params.status);
    }
    if (params.account) {
      form.setFieldsValue({
        account: params.account
      })
    }
  }, [params.status, params.account])
  const onFinish = (values) => {
    // console.log('Received values of form: ', values);
    let account = values.account
    let password = values.password
    setIsLogin(true)
    axios.post('/top_user/login', {
      account: account,
      pwd: password
    }).then(function (response) {
      setIsLogin(false)
      localStorageUtils.save("topUser", response.data)
      if (response.data.isChangePwd > 0) {
        navigate(`/mnt/top-user/reset-password${params.fromPath?`?fromPath=${params.fromPath}`:""}`)
      }
      else {
        if (params.fromPath) {
          navigate(params.fromPath);
        }
        else {
          navigate('/mnt/top-user/');
        }
      }

      console.log(response);
    }).catch(function (error) {
      const status = error.response?.status;
      const remainingMins = error.response?.data?.remaining_mins
        || error.response?.data?.message?.match(/(\d+)\s*(?:分鐘|minutes?)/i)?.[1]
        || '';
      const errorMsg = t(`error.${status}`, { time: remainingMins, minutes: remainingMins }) || 'Login Failed!';
      message.error(errorMsg);
      setIsLogin(false)
      console.log(error);
    });
  };
  return (
    <div className="TopUserLogin">
      <Layout style={{ minHeight: '100vh' }}>
        <Row justify="center" align="middle" style={{ height: 'calc(100vh - 69px)', background: '#f5f5f5' }}>
          <Col xs={22} sm={16} md={12} lg={8} xl={6}>
            <Card style={{ borderRadius: '8px' }}>
              <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>ICEI Admin Sign in</Title>
              <Form
                name="google_login"
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                layout="vertical"
              >
                <Form.Item
                  name="account"
                  rules={[{ required: true, message: 'Please input your account!' }, { type: "email", message: 'It\'s not email format' }]}
                >
                  <Input placeholder="Email" size="large" />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password placeholder="Password" size="large" />
                </Form.Item>
                <Form.Item>
                  <Button loading={isLogin} type="primary" htmlType="submit" style={{ width: '100%', marginTop: '32px' }} size="large">
                    Log in
                  </Button>
                </Form.Item>
              </Form>
              <div style={{ textAlign: 'center' }}>
                <Text>Forgot your password? <Link to="/mnt/top-user/forget-password">Reset it here</Link></Text>
                <br />
                {/* <Text>Don't have an account? <a href="#">Sign up now</a></Text> */}
              </div>
            </Card>
          </Col>
        </Row>
        <Footer style={{ textAlign: 'center' }}>©2024 Your Company Name. All Rights Reserved.</Footer>
      </Layout>
    </div>
  );
}

export default Login;
